export default __webpack_public_path__ + "static/g3two-a634ce72158e11266d3112557804fc47.jpg";